import { FormGroup, FormControlLabel, Switch, Button, List, ListItem, ListItemText, FormLabel, Divider, MenuItem } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { ScrollWrapper } from "../../../digitalArena/helpers/module.helper";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import { screenshareLayouts } from "../../../digitalArena/modules/Vonage/components/VonageScreenshare";
import StopIcon from "@material-ui/icons/Stop";
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import Menu from "@material-ui/core/Menu";
import { toTitleCase } from "../../../helpers/stringHelper";

export default function VonageBackstageModeratorTab(props) {
  const [recordingBtnDisabled, setRecordingBtnDisabled] = useState(false);
  const [studioStreamBtnDisabled, setStudioStreamBtnDisabled] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  function onRecordingBtnPress() {
    props.toggleRecording();
    setRecordingBtnDisabled(true);
    setTimeout(() => {
      setRecordingBtnDisabled(false);
    }, 2000);
  }
  function toggleStudioStream() {
    props.toggleStudioStream();
    setStudioStreamBtnDisabled(true);
    setTimeout(() => {
      setStudioStreamBtnDisabled(false);
    }, 2000);
  }
  return (
    <div
      style={{
        background: "#333333",
        borderColor: "unset",
        borderWidth: "0px",
        borderRadius: "0px",
        boxShadow: "none",
        width: "100%",
        height: "100%",
        display: "flex",
        position: "relative",
        justifyItems: "flex-start",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <ScrollWrapper {...props}>
        <List
          className="jir-scroll"
          style={{
            paddingTop: 0,
            overflowY: "auto",
            borderRadius: "inherit",
            height: "100%",
            paddingTop: 15,
          }}
        >
          <ListItem style={{ margin: `5px auto`, paddingTop: "0px", paddingBottom: "0px" }}>
            <FormGroup>
              <FormLabel className="secondary-text">
                <SystemLabel name="RecordSession" />
              </FormLabel>
              <Button
                startIcon={props.isRecording ? <StopIcon /> : <PlayCircleFilledIcon />}
                // className={"go-on-air-btn"}
                style={{
                  background: recordingBtnDisabled ? "#eee" : props.isRecording ? "#d63a3a" : "rgb(22 88 197)",
                  color: "#fff",
                  fontSize: ".8rem",
                  padding: "6px 14px",
                  justifyContent: "center",
                }}
                disabled={recordingBtnDisabled}
                onClick={onRecordingBtnPress}
              >
                {props.isRecording ? <SystemLabel name="StopRecording" /> : null}
                {!props.isRecording ? <SystemLabel name="StartRecording" /> : null}
              </Button>
            </FormGroup>
          </ListItem>
          <br />
          <ListItem style={{ margin: `auto`, paddingTop: "0px", paddingBottom: "0px" }}>
            <FormGroup>
              <FormLabel className="secondary-text">
                <SystemLabel name="ScreenShareLayout" />
              </FormLabel>
              <Button
                className="backstage-secondary-btn"
                endIcon={!Boolean(anchorEl) ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                {props.screenshareLayout}
              </Button>
              <Menu
                PaperProps={{
                  style: {
                    color: "#eee",
                    background: "#3b3b3b",
                  },
                }}
                MenuListProps={{
                  style: {
                    color: "#eee",
                    background: "#3b3b3b",
                  },
                }}
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {screenshareLayouts.map((t) => {
                  return (
                    <MenuItem
                      key={t}
                      value={t}
                      onClick={(e) => {
                        handleClose();
                        props.changeScreenshareLayout(t);
                      }}
                    >
                      {t}
                    </MenuItem>
                  );
                })}
              </Menu>
            </FormGroup>
          </ListItem>
          <br />
          <ListItem style={{ margin: `5px auto`, paddingTop: "0px", paddingBottom: "0px" }}>
            <FormGroup>
              <FormLabel className="secondary-text">
                <SystemLabel name="ActivateStudioStream" />
              </FormLabel>
              <Button
                startIcon={props.isStudioStream ? <StopIcon /> : <PlayCircleFilledIcon />}
                // className={"go-on-air-btn"}
                style={{
                  background: studioStreamBtnDisabled ? "#eee" : props.isStudioStream ? "#d63a3a" : "rgb(22 88 197)",
                  color: "#fff",
                  fontSize: ".8rem",
                  padding: "6px 14px",

                  justifyContent: "center",
                }}
                disabled={studioStreamBtnDisabled}
                onClick={toggleStudioStream}
              >
                {props.isStudioStream ? <SystemLabel name="Deactivate" /> : null}
                {!props.isStudioStream ? <SystemLabel name="Activate" /> : null}
              </Button>
            </FormGroup>
          </ListItem>
        </List>
      </ScrollWrapper>
    </div>
  );
}
